import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  paper: {
    width: "100%"
  }
}))
